export class JurisdictionObligationSimpleListItem {
    id: string;
    name: string;
}